import { surveyInfoTexts } from '@src/components/survey/surveyData';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'theme-ui';
import SurveyImage0 from './surveyImages/surveyImage0';
import SurveyImage1 from './surveyImages/surveyImage1';
import SurveyImage2 from './surveyImages/surveyImage2';
import SurveyImage3 from './surveyImages/surveyImage3';
import SurveyImage4 from './surveyImages/surveyImage4';
import SurveyImage5 from './surveyImages/surveyImage5';
import SurveyImage6 from './surveyImages/surveyImage6';

type rightSideSurveyProps = {
  surveyQuestion: number;
};

function SurveyRightSide({ surveyQuestion }: rightSideSurveyProps) {
  const { t, i18n } = useTranslation();

  {
    /* TODO: MOK-202 get images from gatsby instead of code bellow with sttic images from files  */
  }
  // const data = useStaticQuery(graphql`
  //   query {
  //     allContentfulMokomasisDalykas(sort: { name: ASC }) {
  //       nodes {
  //         ...SubjectsInfo
  //         navIcon: icon {
  //           gatsbyImageData(
  //             width: 1000
  //             quality: 100
  //             placeholder: BLURRED
  //             formats: [AUTO, WEBP]
  //           )
  //         }
  //       }
  //     }
  //   }
  // `);
  // const subjectsData = filterLocaleNodesSubjects(
  //   data.allContentfulMokomasisDalykas.nodes,
  //   i18n.language
  // );
  return (
    <Box
      bg="primaryPaleBg"
      className="survey-box__right-side"
      sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      <Box
        sx={{
          borderRadius: 'inherit',
          maxHeight: '500px',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {surveyQuestion === 0 && <SurveyImage0 />}
        {surveyQuestion === 1 && <SurveyImage1 />}
        {surveyQuestion === 2 && <SurveyImage2 />}
        {surveyQuestion === 3 && <SurveyImage3 />}
        {surveyQuestion === 4 && <SurveyImage4 />}
        {surveyQuestion === 5 && <SurveyImage5 />}
        {surveyQuestion === 6 && <SurveyImage6 />}

        {/* TODO: MOK-202 map photos form gatsby instead of code above with static images from files  */}
        {/* {subjectsData?.map((subject, index) => {
          const image = getImage(subject.navIcon);
          if (surveyQuestion === index) {
            return <GatsbyImage key={index} image={image} alt="" />;
          }
        })} */}
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          margin: 'auto',
        }}
      >
        {surveyInfoTexts?.map((text, index) => (
          <Box
            className="survey-box__right-side__text"
            key={index}
            sx={{
              display: surveyQuestion === index ? 'block' : 'none',
            }}
            dangerouslySetInnerHTML={{
              __html: `${text && t('survey.' + text)}`,
            }}
          ></Box>
        ))}
      </Box>
    </Box>
  );
}

export default SurveyRightSide;
